import React, {Fragment} from 'react';
import {Form, InputGroup} from "react-bootstrap";
import InlineSVG from "react-inlinesvg";
import searchIcon from "../../../../../assets/svg/actions/icn-search.svg";
import Tools from "../../../../../Tools";
import '../../../../../assets/sass/pages/scouting/discussion.scss';
import ChatBubbles from "../../../../ui/messages/ChatBubbles";
import ChatSend from "../../../../ui/messages/ChatSend";
import ChatReceive from "../../../../ui/messages/ChatReceive";
import ShadowScrollbars from "../../../../ui/custom_scrollbars/ShadowScrollbars";
import avatar from "../../../../../assets/img/demo/player-avatar-1.png";

class Discussion extends React.Component {

    shadowScrollbarsRef = React.createRef();
    discussionAreaRef = React.createRef();
    chatBubblesRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            search: '',

            discussion: [
                { type: "receive", avatar: avatar, name: "Ahmad",  message: "After evaluating the report I think seem to be good at front"},
                { type: "send", avatar: avatar, name: "Ahmad", message: "Hi guys here sharing the evaluation report please put your comments"},
                { type: "receive", avatar: avatar, name: "Ahmad", message: "After evaluating the report I think seem to be good at front"},
                { type: "send", avatar: avatar, name: "Ahmad", message: "Yeh Thats right"},
            ]
        };
    }

    componentDidMount() {
        // this.shadowScrollbarsRef.current.refs.scrollbars.scrollTop(this.discussionAreaRef.current.getBoundingClientRect().height);
    }

    render() {
        var {searchPlaceholder} = this.props;
        const items = this.filteredItems();
        const id = this.customId();

        return (
            <div className="discussion">
                <div className="search">
                    <InputGroup className="input-group-white-lg">
                        <Form.Control name="text" placeholder={ searchPlaceholder ?? 'Search Comment' } className="input input-white input-lg" onChange={this.handleSearch} />
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <i><InlineSVG src={searchIcon}/></i>
                            </InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                </div>
                <div className="discussion-body">
                    <ShadowScrollbars ref={this.shadowScrollbarsRef}>
                        <div ref={this.discussionAreaRef} className="discussion-area">
                            {this.discussionContent()}
                        </div>
                    </ShadowScrollbars>
                    <div className="chat-send-wrapper">
                        <ChatBubbles ref={this.chatBubblesRef} placeholder="Type your comment here..." onSubmit={this.ChatBubbleSubmit} onAttachmentSubmit={this.ChatBubbleSubmit}/>
                    </div>
                </div>
            </div>
        )
    }

    discussionContent = () => {
        var {discussion} = this.state;
        return discussion.map((item) => {
            return item.type == 'send' ? (
                <ChatSend data={item}></ChatSend>
            ) : (
                <ChatReceive data={item}></ChatReceive>
            )
        })
    }

    ChatBubbleSubmit = (event, data) => {
        if(data.message || data.attachment.name)
            this.setState({
                discussion: [
                    ...this.state.discussion,
                    { type: 'send', avatar: avatar, name: "Ahmad", ...data}
                ]
            }, function () {
                this.shadowScrollbarsRef.current.refs.scrollbars.scrollTop(this.discussionAreaRef.current.getBoundingClientRect().height);
            });
    }

    /**
     * Filters items list.
     * @param event {object} The change event.
     */
    handleSearch = (event) => {
        const value = event.target.value;

        this.setState({
            search: value,
        });
    };

    /**
     * Returns the filtered items of tab controller.
     * @returns {React.ReactNode} The filtered tab controller items.
     */
    filteredItems = () => {
        return this.items().filter(item => Tools.findInArray(item.searchableFields, this.state.search));
    };

    /**
     * Returns the id of vertical tab component.
     * @returns {React.ReactNode} The component id.
     */
    customId = () => this.props.id ?? Tools.generateToken(16);

    /**
     * Returns the items of tab controller.
     * @returns {React.ReactNode} The tab controller items.
     */
    items = () => this.props.items ?? [];
}

export default Discussion;
